export const columnHeaders = {
  "& div": {
    display: "flex",
    // justifyContent: "space-between",
  },

  backgroundColor: "#f9f9f9",
  color: " #9b9b9b",
  fontSize: "12px",
  fontWeight: "bold",
  textTransform: "uppercase",
}
